import dynamic from 'next/dynamic';

const TrafficOffensesGrid = dynamic(() =>
  import('./TrafficOffensesGrid/TrafficOffensesGrid')
);
const TrafficOffensesAddNewModal = dynamic(() =>
  import('./TrafficOffensesAddNewModal/TrafficOffensesAddNewModal')
);

const TrafficOffensesForm = dynamic(() =>
  import('./TrafficOffensesForm/TrafficOffensesForm')
);
const TrafficOffensesDocumentModal = dynamic(() =>
  import('./TrafficOffensesDocumentModal/TrafficOffensesDocumentModal')
);

const TrafficOffensesListContent = dynamic(() =>
  import('./TrafficOffensesListContent/TrafficOffensesListContent')
);
const TrafficOffensesTaskDetails = dynamic(() =>
  import('./TrafficOffensesTaskDetails/TrafficOffensesTaskDetails')
);
const TrafficOffencesFilters = dynamic(() =>
  import('./TrafficOffencesFilters/TrafficOffencesFilters')
);

export {
  TrafficOffensesGrid,
  TrafficOffensesAddNewModal,
  TrafficOffensesForm,
  TrafficOffensesDocumentModal,
  TrafficOffensesListContent,
  TrafficOffensesTaskDetails,
  TrafficOffencesFilters,
};
